import { useQuery } from '@tanstack/react-query'
import { listVndlyTimesheetIssues } from 'api/vndly/listTimesheetIssues'
import { vndlyKeys } from './keys'

type UseVndlyTimesheetIssuesQueryParams = Parameters<
  typeof listVndlyTimesheetIssues
>[0]
type UseVndlyTimesheetIssuesQueryData = Awaited<
  ReturnType<typeof listVndlyTimesheetIssues>
>

export function useVndlyTimesheetIssuesQuery(
  params: UseVndlyTimesheetIssuesQueryParams,
  enabled = true
) {
  return useQuery<UseVndlyTimesheetIssuesQueryData>({
    queryKey: vndlyKeys.timesheetIssues(params),
    queryFn: ({ signal }) => listVndlyTimesheetIssues(params, signal),
    enabled: enabled && params.companyIds.length > 0,
  })
}
